import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.p`
  ${_ref => {
  let {
    $textOverflow
  } = _ref;
  return $textOverflow && `overflow-wrap: anywhere;`;
}};
  color: ${_ref2 => {
  let {
    $color,
    theme
  } = _ref2;
  return genericColor(theme, $color);
}};
  ${_ref3 => {
  let {
    $fontSize,
    theme
  } = _ref3;
  return $fontSize && `font-size: ${$fontSize * theme.typography.fontStep}rem`;
}};
  ${_ref4 => {
  let {
    $lineHeight,
    theme
  } = _ref4;
  return $lineHeight && `line-height: ${$lineHeight * theme.typography.fontStep}rem`;
}};
  ${_ref5 => {
  let {
    $weight,
    theme
  } = _ref5;
  return $weight && `font-weight: ${theme.typography.fontWeight[$weight]}`;
}};
  ${_ref6 => {
  let {
    $s,
    theme
  } = _ref6;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref7 => {
  let {
    $display
  } = _ref7;
  return $display && `display: ${$display}`;
}};
  ${_ref8 => {
  let {
    $align
  } = _ref8;
  return $align && `text-align: ${$align}`;
}};
`;
const Text = _ref9 => {
  let {
    element = "span",
    color = "inherit",
    weight,
    fontSize,
    lineHeight,
    display,
    textOverflow = false,
    align,
    s,
    children,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    as: element,
    $color: color,
    $weight: weight,
    $fontSize: fontSize,
    $lineHeight: lineHeight,
    $textOverflow: textOverflow,
    $display: display,
    $align: align,
    $s: s
  }, rest), children);
};
export default Text;